import { useTranslation } from 'react-i18next';
import { Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import LOCKED_VIEW from '@hotjar/shared-assets/images/feedback/person-wondering-about-locked-view.png';
import moment from 'moment';

const Container = styled.div`
  text-align: center;
`;

const Img = styled.img`
  max-width: 250px;
`;

const Title = styled(Text)`
  margin: 0 0 ${tokens.spacer.x1};
`;

const Subtitle = styled(Text)`
  margin: 0 0 ${tokens.spacer.x3};
`;

export interface PausedResponsesProps {
  date: Date | null;
}

export const PausedResponses = ({ date }: PausedResponsesProps): JSX.Element | null => {
  const { t } = useTranslation('feedback');

  if (!date) return null;

  const rolloverDate = moment(date).format('MMMM D');

  const title = t('feedback:empty-states.paused-responses.title');

  return (
    <Container>
      <Img alt="" src={LOCKED_VIEW} />
      <Title as="h4" textType="header4" textColor="text_default">
        {title}
      </Title>
      <Subtitle as="p" textType="subtitle1" textColor="text_light">
        {t('feedback:empty-states.paused-responses.subtitle', { date: rolloverDate })}
      </Subtitle>
    </Container>
  );
};
